<script setup lang="ts">
/**
 * @file Screen size aware drawer modal that renders OzDrawer on phone and OzCenterModal on desktop. Used in Content picker.
 */
import OzCenterModal from '@@/library/v4/components/OzCenterModal.vue'
import OzDrawerDraggable from '@@/library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from '@@/library/v4/components/OzDrawerStatic.vue'

withDefaults(
  defineProps<{
    isPhone?: boolean
    isDraggableDrawer?: boolean
  }>(),
  {
    isPhone: false,
    isDraggableDrawer: false,
  },
)

defineEmits(['scrim-click', 'scrim-esc', 'swipedown', 'swipeup'])
</script>

<script lang="ts">
export default {}
</script>

<template>
  <OzDrawerStatic
    v-if="isPhone && !isDraggableDrawer"
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
  >
    <template #header><slot name="header" /></template>
    <template #body><slot name="body" /></template>
    <template #footer><slot name="footer" /></template>
  </OzDrawerStatic>
  <OzDrawerDraggable
    v-else-if="isPhone && isDraggableDrawer"
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
    @swipedown="$emit('swipedown', $event)"
    @swipeup="$emit('swipeup', $event)"
  >
    <template #header><slot name="header" /></template>
    <template #body><slot name="body" /></template>
    <template #footer><slot name="footer" /></template>
  </OzDrawerDraggable>
  <OzCenterModal
    v-else
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
  >
    <template #header><slot name="header" /></template>
    <template #body><slot name="body" /></template>
    <template #footer><slot name="footer" /></template>
  </OzCenterModal>
</template>
